export const passwordRuleMessage =
  "Le mot de passe doit contenir au moins 8 caractères, une majuscule, une minuscule et un chiffre.";

export function getPasswordValidationError(value: string) {
  if (!value.trim()) {
    return "Le mot de passe est obligatoire.";
  }

  if (value.length < 8) {
    return "Le mot de passe doit contenir au moins 8 caractères.";
  }

  if (!/[A-Z]/.test(value)) {
    return "Le mot de passe doit contenir une majuscule.";
  }

  if (!/[a-z]/.test(value)) {
    return "Le mot de passe doit contenir une minuscule.";
  }

  if (!/[0-9]/.test(value)) {
    return "Le mot de passe doit contenir un chiffre.";
  }

  return undefined;
}
